export default __webpack_public_path__ + "static/media/our-services-social-care-learning-disability-day-centers-01.640ae102.jpg";